import { Link } from 'react-router-dom';
import { faqItems } from '@/mocks/faq';

export default function FaqPreview() {
  const items = faqItems.slice(0, 3);
  return (
    <section className="border-t border-background-200 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-medium text-primary-800">
              <i className="ri-question-line text-sm" aria-hidden="true"></i>
              常见问题
            </span>
            <h2 className="mt-4 text-2xl leading-relaxed text-foreground-950 md:text-3xl">关于这部漫画，你最想知道的几个问题</h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              我们整理了新老读者最常问的问题，从“洞洞是什么意思”到“从哪开始读”，帮你快速扫清入门障碍。
            </p>
            <Link
              to="/faq"
              className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              查看全部问答
              <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="space-y-4">
            {items.map((item) => (
              <div key={item.q} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <h3 className="flex items-start gap-3 text-base font-semibold text-foreground-950">
                  <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-accent-500 text-xs text-background-50">Q</span>
                  {item.q}
                </h3>
                <p className="mt-3 pl-9 text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}